import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux'
import './Payouts.css'



const Head = (props) => {
    //get props
    const user = props.user
    const teams = props.teams

    let Fanatics = 'https://firebasestorage.googleapis.com/v0/b/sports-market.appspot.com/o/website%2FFanaticsLogo.png?alt=media&token=c61c1b1e-064b-47d8-a8ac-8d65ef531a71'

    return(
        <div className='Head'>

            <div style={{textAlign: 'center', fontSize: '1.3em', fontWeight: '200', marginTop: '15px'}}>Win Payouts Sponsored By</div>
            <a href="https://fanatics.93n6tx.net/ORyG2r">
            <div>
                <img src={Fanatics} style={{width: '80%', marginLeft: '10%', marginTop: '10px'}} />
            </div>
            <div style={{textAlign: 'center', fontWeight: '200', width: '80%', marginLeft: '10%', marginTop: '10px', color: 'gray'}}>Click here to start shopping at Fanatics.com for Free Shipping over $99</div>
            </a>

        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    teams: state.teams.teams.teams
});

export default connect(mapStateToProps)(Head)